import { ErrorDisplay } from "@web/components/error-display";
import { getCurrentProduct } from "@web/config";
import { useQrVerification } from "@web/lib/hooks/use-qr-verification";
import { useNavigate, useParams } from "react-router";
import { useSearchParams } from "react-router-dom";

export function QrCodeQuery() {
	const { hash: paramHash } = useParams();
	const [searchParams] = useSearchParams();
	const navigate = useNavigate();
	const { QrCodeQueryLoading } = getCurrentProduct();

	const hash = paramHash || searchParams.get("hash") || undefined;

	const { error, is404Error, cachedQuery, data, isPending, updateState } =
		useQrVerification(hash);

	if (error)
		return (
			<ErrorDisplay
				message={error}
				onRetry={() => window.location.reload()}
				is404={is404Error}
			/>
		);
	if (!hash)
		return (
			<ErrorDisplay message="Hash não encontrado. Verifique o QR code e tente novamente." />
		);
	if (isPending) return <QrCodeQueryLoading />;

	const sealData = data || cachedQuery;

	if (sealData) {
		const { seal, query } = sealData;

		if (!seal)
			return (
				<ErrorDisplay
					message="Dados do selo não encontrados ou inválidos."
					onRetry={() => window.location.reload()}
				/>
			);

		try {
			navigate(`/tutorial/${query.id}?hash=${hash}`);
		} catch (err) {
			updateState({
				error: "Erro ao navegar para a câmera. Por favor, tente novamente.",
			});
		}
	}

	return (
		<ErrorDisplay
			message="Ocorreu um erro inesperado. Por favor, tente novamente."
			onRetry={() => window.location.reload()}
		/>
	);
}
